// extracted by mini-css-extract-plugin
module.exports = {"UsageScenariosC":"UsageScenariosC_UsageScenariosC__ES7Xk"};